var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.001 22.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M22.111 16.974v3.011a2.01 2.01 0 0 1-2.192 2.007 19.926 19.926 0 0 1-8.678-3.081 19.59 19.59 0 0 1-6.034-6.022 19.836 19.836 0 0 1-3.087-8.7A2.009 2.009 0 0 1 4.121 2h3.017a2.01 2.01 0 0 1 2.011 1.726 12.865 12.865 0 0 0 .7 2.82A2 2 0 0 1 9.4 8.664L8.123 9.938a16.074 16.074 0 0 0 6.034 6.022l1.277-1.275a2.014 2.014 0 0 1 2.122-.452 12.933 12.933 0 0 0 2.826.7 2.008 2.008 0 0 1 1.73 2.037z",
    transform: "translate(-1.111 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherPhone);
export default __webpack_public_path__ + "static/media/icon-feather-phone.e6ae67ea2fa2e77731286385a34904ef.svg";
export { ForwardRef as ReactComponent };